import React from 'react'
import { PartialCoverdImage } from 'components/PartialCoverdImage'
import { ImageCredits } from 'components/ImageCredits'
import { Quote } from 'components/Quote'
import { PersonIntroduction } from 'components/PersonIntroduction'

export const Hazeta = ({
  size,
  colors
}: {
  size: { width: number; height: number; isMobile: boolean }
  colors: { main: string; sub: string; cover: string }
}) => (
  <div className='ui vertical segment'>
    <div className='ui text container'>
      <div className='ta text'>
        <PersonIntroduction
          name='Hazeta Salihović'
          sub={
            <>
              56, Kinderbetreuerin, Gais,
              <br /> seit 1992 in der Schweiz, Stimmrecht seit 2019
            </>
          }
          img={require('images/hazeta_quad.jpg')}
          colors={colors}
        />
        <p>
          «Lange waren die Bücher, die ich schreibe, die wichtigste Form, wie ich
          meine Stimme und meine Erlebnisse zum Ausdruck bringe. Schon als
          kleines Mädchen habe ich gerne Geschichten und Gedichte geschrieben.
        </p>
        <p>
          1992 flüchtete ich mit meinen zwei kleinen Kindern vor dem Krieg in
          Bosnien-Herzegowina. In meiner Heimat arbeitete ich als Biologie- und
          Chemielehrerin. Als ich in die Schweiz kam, brachte ich die Familie
          mit verschiedenen Hilfsjobs über die Runden. Damals starb meine Mutter
          in Bosnien, der Krieg sass mir in den Knochen, ich war mit dem dritten
          Kind schwanger. Es war die schlimmste Zeit meines Lebens, und ich
          konnte mich in dieser Situation nicht richtig ausdrücken. Ich musste
          erst Deutsch lernen, um mir Gehör zu verschaffen.
        </p>
        <p>
          Nach Bosnien zurückzukehren, war für mich auch nach dem Krieg
          unmöglich. Mein Dorf war komplett zerstört. Ich wollte meinen Kindern
          eine sichere Zukunft bieten und blieb in der Schweiz.
        </p>
        <Quote infos={'Hazeta Salihović'} colors={colors}>
          «Frauen, egal wie alt ihr seid, verschafft euch eine Stimme, sagt eure Meinung.»
        </Quote>
        <p>
          Nun kümmere ich mich seit zehn Jahren um Kinder am Mittagstisch und in
          der Nachmittagsbetreuung in der Schule im appenzellischen Teufen. Es
          ist nicht, was ich gelernt habe, aber die Arbeit mit den Kindern macht
          mich glücklich.
        </p>
        <p>
          2019 verschaffte ich mir mit der Einbürgerung auch eine politische
          Stimme. Endlich, nach 30 Jahren in der Schweiz. Meine erste
          Volksabstimmung war die Konzernverantwortungsinitiative 2020. Obwohl
          ich mich auch zuvor als Teil der Gesellschaft fühlte, mich in Vereinen
          und der Umweltschutzkommission unserer Gemeinde einbrachte, war es
          ernüchternd, gewisse Ergebnisse nicht aktiv beeinflussen zu können. In
          solchen Momenten wünschte ich mir das Stimmrecht auch ohne
          Staatsbürgerschaft.
        </p>
      </div>
    </div>
    <div className='ui container '>
      <PartialCoverdImage
        url={size.isMobile ? 'hazeta_hoch.jpg' : 'hazeta_quer.jpg'}
        covers={
          size.isMobile
            ? ['bottom right', 'top left']
            : ['bottom left', 'top right']
        }
        colors={colors}
        infos={[
          size.isMobile ? 'bottom right' : 'bottom left',
          <ImageCredits
            noSpace
            text='Seit ihre drei Kinder mit ihren Ausbildungen fertig und ausgezogen sind, hat Hazeta Salihović wieder mehr Zeit für sich – und fürs Schreiben.'
            colors={colors}
          />
        ]}
      />
    </div>{' '}
    <div className='ui text container '>
      <div className='ta text'>
        <p>
          Es ist ein Privileg, seine Meinung frei ausdrücken zu dürfen und sich
          darauf verlassen zu können, dass insbesondere auf politischer Ebene
          die eigene Stimme nicht manipuliert wird oder nicht zählt, weil sie
          etwa von einer Frau stammt.
        </p>
        <p>
          Die oft tiefe Stimmbeteiligung in der Schweiz erkläre ich mir so: In
          unserer funktionierenden Demokratie vertrauen wohl viele darauf, dass
          die jeweils anderen abstimmen gehen. Gerade bei nicht besonders
          ‹kritischen› Vorlagen. Ich finde: Jede und jeder sollte diese
          Verantwortung selbst übernehmen.
        </p>
        <p>
          Ich wünsche allen Frauen: Habt Mut, das Zepter selbst in die Hand zu
          nehmen! Egal, wie alt ihr seid, verschafft euch eine Stimme, sagt eure
          Meinung, tut es auf eure ganz eigene Art und Weise. Wir brauchen mehr
          Frauen in der Politik, in Führungspositionen. Wir dürfen dabei nicht
          auf eine Quote vertrauen. Wir müssen diesen Schritt selber machen.»
        </p>
      </div>
    </div>
  </div>
)
